module.exports = __webpack_public_path__ + "static/media/nashville-hot-chicken-sandwich-desktop-fr.3803d32d.jpg";